@if (consignmentProcess) {
  <app-consignment-details-alerts></app-consignment-details-alerts>
  <div class="modal-header">
    <div class="flex-container align-items-center">
      <button type="button" class="btn-close me-2 d-inline-flex" data-bs-dismiss="modal" aria-label="Close"></button>
      <div class="d-inline-flex me-1">
        <i class="fa fa-fw fa-light fa-lg fa-file-lines text-muted"></i>
      </div>
      <span class="page-title">{{ masterLevel.consignmentNumber }}</span>
      @if (consignmentProcess.cancelled) {
        <app-tooltip placement="bottom" class="ms-2">
          <span class="fa text-danger fa-fw fa-ban"></span>
          <span class="tooltipContent">Cancelled</span>
        </app-tooltip>
      }
    </div>
  </div>
  <div class="modal-body p-0" [ngClass]="editMode ? 'edit-mode' : ''">
    <app-tab-panel [sticky]="true" [alwaysRender]="true" (tabChange)="onTabChange($event)">
      <app-tab-item [templateRef]="detailsRef">
        <div class="tab-item">
          <span errorIndicator [mainPredicate]="masterLevelPredicate" [overrideRef]="elementRef"></span>
          Details
        </div>
        <ng-template #detailsRef>
          <div class="container py-3">
            <div class="card">
              <div class="card-body p-5">
                <div class="row gy-4 my-0">
                  <h5 class="h1 col-12 m-0">Master bill of lading details</h5>
                  @if (mainFilingChoice) {
                    <div class="col-12">
                      <div class="row gy-4">
                        <app-form-field label="Union goods transported under Regular Shipping Service License"
                                        class="col-12 col-md-6" [(value)]="mainFilingChoice" [includeMargin]="false"
                                        [editMode]="editMode" [renderOptional]="false"
                                        [formatter]="refData.enumFormatter" [tooltipTemplateRef]="mainFilingTooltip">
                          <app-radio [(ngModel)]="mainFilingChoice"
                            (ngModelChange)="updateFilingType()"
                            [inline]="true" [options]="mainFilingChoiceTypes"
                            [formatter]="refData.enumFormatter"
                          [required]="true"></app-radio>
                        </app-form-field>
                      </div>
                    </div>
                  }
                  @if (billOfLadingFilingType && (mainFilingChoice == MainFilingChoice.NO)) {
                    <div class="col-12">
                      <div class="row gy-4">
                        <app-form-field label="Mode of transport" class="col-6 col-md-3"
                          [(value)]="billOfLadingFilingType.modeOfTransportType"
                          [includeMargin]="false" [editMode]="editMode" [renderOptional]="false"
                          [formatter]="refData.enumFormatter"
                          [tooltipTemplateRef]="modeOfTransportTooltip">
                          <app-radio [(ngModel)]="billOfLadingFilingType.modeOfTransportType"
                            (ngModelChange)="updateFilingType()"
                            [inline]="true" [options]="modeOfTransportTypes"
                            [formatter]="refData.enumFormatter"
                          [required]="true"></app-radio>
                        </app-form-field>
                        @if (!rules.isRoadConsignment(consignmentProcess)) {
                          <app-form-field
                            label="Bill of lading type" class="col-6 col-md-3"
                            [(value)]="billOfLadingFilingType.billOfLadingType"
                            [includeMargin]="false" [editMode]="editMode" [renderOptional]="false"
                            [formatter]="refData.enumFormatter" [tooltipTemplateRef]="billOfLadingTooltip">
                            <app-radio [(ngModel)]="billOfLadingFilingType.billOfLadingType"
                              (ngModelChange)="billOfLadingTypeChanged($event)"
                              [inline]="true" [options]="billOfLadingTypes" [formatter]="refData.enumFormatter"
                            [required]="true"></app-radio>
                          </app-form-field>
                        }
                      </div>
                    </div>
                  }
                  @if (showDetails()) {
                    <div class="col-12">
                      <div class="row gy-4">
                        <app-form-field label="Master bill of lading number" class="col-6 col-md-4"
                          [(value)]="masterLevel.consignmentNumber"
                          [includeMargin]="false" [editMode]="editMode && isNewConsignment"
                          [renderOptional]="false">
                          <input class="input-group form-control"
                            (change)="masterLevel.consignmentNumber=$event.target.value.toUpperCase()"
                            [(ngModel)]="masterLevel.consignmentNumber" required
                            (ngModelChange)="setConsignmentProcessId($event)"/>
                        </app-form-field>
                        @if (rules.isSplintConsignmentAllowed(consignmentProcess)) {
                          <app-form-field
                            label="Split from BL with MRN" class="col-6 col-md-4"
                            [(value)]="consignmentProcess.filing.splitConsignmentPreviousMrn"
                            [editMode]="editMode"
                            [includeMargin]="false">
                            <input class="input-group form-control"
                              [(ngModel)]="consignmentProcess.filing.splitConsignmentPreviousMrn"/>
                          </app-form-field>
                        }
                        @if (appContext.isAdminOrCustoms() && consignmentProcess.filing?.declarant) {
                          <app-form-field label="Cargo declarant" [editMode]="false" class="col-6 col-md-4"
                                          [includeMargin]="false" [(value)]="consignmentProcess.filing.declarant.fullName">
                            <input class="input-group form-control" [(ngModel)]="consignmentProcess.filing.declarant.fullName"/>
                          </app-form-field>
                        }
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row gy-4">
                        <app-form-field label="Trader assigned reference" class="col-6 col-md-4"
                          [(value)]="masterLevel.traderAssignedReference"
                          [editMode]="editMode"
                          [includeMargin]="false">
                          <input class="input-group form-control" [(ngModel)]="masterLevel.traderAssignedReference"/>
                        </app-form-field>
                        @if (showEnsLrn) {
                          <app-form-field label="ENS local reference number (LRN)" class="col-6 col-md-4"
                                          [includeMargin]="false" [value]="ensLrn" [editMode]="false">
                          </app-form-field>
                        } @else {
                          <app-form-field label="ENS movement reference number" class="col-6 col-md-4"
                                          [includeMargin]="false" [(value)]="ensMrn"
                                          [editMode]="editMode && !consignmentProcess.filing.declarant?.ensEnabled">
                            <input class="input-group form-control" [(ngModel)]="ensMrn"/>
                          </app-form-field>
                        }
                        @if (showTsLrn) {
                          <app-form-field label="TS local reference number (LRN)" class="col-6 col-md-4"
                                          [includeMargin]="false"
                                          [value]="consignmentProcess.functionalReferenceId"
                                          [editMode]="false">
                          </app-form-field>
                        } @else {
                          <app-form-field label="TS movement reference number" class="col-6 col-md-4"
                                          [includeMargin]="false"
                                          [value]="consignmentProcess.status?.filingStatusTemporaryStorage?.registrationResponse?.mrn"
                                          [editMode]="false">
                          </app-form-field>
                        }
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row gy-4">
                        @if (!rules.isRoadConsignment(consignmentProcess)) {
                          <app-form-field label="Call reference number" class="col-6 col-md-4"
                            [(value)]="consignmentProcess.filing.crn" [editMode]="editMode"
                            [includeMargin]="false">
                            <app-search [(ngModel)]="consignmentProcess.filing.crn"
                                        (ngModelChange)="onCrnChange($event)" placeholder="Search for visit"
                                        dataKey="crn" [required]="rules.isCrnRequired(this.consignmentProcess)"
                                        [inputFormatter]="utils.visitFormatter" [resultFormatter]="utils.visitFormatter"
                                        [minCharacters]="2" [searchFunction]="utils.findVisits"></app-search>
                          </app-form-field>
                          @if (entryCrnRequired || hasEntryCrn) {
                            <app-form-field label="Call reference number for Entry" class="col-6 col-md-4"
                                            [(value)]="consignmentProcess.filing.entryCrn" [editMode]="editMode"
                                            [includeMargin]="false">
                              <app-search [(ngModel)]="consignmentProcess.filing.entryCrn" dataKey="crn"
                                          (ngModelChange)="consignmentProcess.filing.entryCrn = $event?.crn"
                                          [placeholder]="'Search for visit in port ' + (portEnteringEu?.name ?? '')"
                                          [required]="true" [inputFormatter]="utils.visitFormatter" [resultFormatter]="utils.visitFormatter"
                                          [minCharacters]="2" [searchFunction]="utils.findVisits"></app-search>
                            </app-form-field>
                          }
                        }
                        <app-form-field label="Voyage number" class="col-6 col-md-4"
                          [(value)]="masterLevel.agentVoyageNumber"
                          [editMode]="editMode" [includeMargin]="false">
                          <input class="input-group form-control"
                            [disabled]="!rules.isVoyageNumberAllowed(consignmentProcess)"
                            [(ngModel)]="masterLevel.agentVoyageNumber"/>
                        </app-form-field>
                      </div>
                    </div>
                    @if (!rules.isRoadConsignment(consignmentProcess)) {
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Vessel" class="col-6 col-md-4"
                            [(value)]="masterLevel.activeBorderTransportMeans.vehicle"
                            [editMode]="editMode" [includeMargin]="false" [formatter]="vehicleFormatter"
                            [checkForErrors]="true">
                            <app-search
                              [(ngModel)]="masterLevel.activeBorderTransportMeans.vehicle"
                              [searchFunction]="searchVessel" [inputFormatter]="vehicleFormatter"
                              [disabled]="rules.isDutchPort(consignmentProcess)"
                              [minCharacters]="3" placeholder="Name or IMO number" dataKey="imoCode" id="vesselName"
                              required>
                            </app-search>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    @if (rules.isRoadConsignment(consignmentProcess)) {
                      <div class="col-12">
                        <span class="h2">Vehicle</span>
                        <div class="row gy-4">
                          <app-form-field label="Identification type" class="col-6 col-md-4"
                            [value]="masterLevel.activeBorderTransportMeans.vehicle.typeOfIdentification"
                            [editMode]="editMode"
                            [includeMargin]="false"
                            [formatter]="typeOfIdentificationFormatter">
                            <app-search required
                              [(ngModel)]="masterLevel.activeBorderTransportMeans.vehicle.typeOfIdentification"
                              [options]="typeOfIdentifications"
                            [inputFormatter]="typeOfIdentificationFormatter"></app-search>
                          </app-form-field>
                          <app-form-field label="Description" class="col-6 col-md-4"
                            [value]="masterLevel.activeBorderTransportMeans.vehicle.typeOfMeansOfTransport"
                            [editMode]="editMode"
                            [formatter]="typeOfMeansOfTransportFormatter"
                            [includeMargin]="false">
                            <app-search required
                              [(ngModel)]="masterLevel.activeBorderTransportMeans.vehicle.typeOfMeansOfTransport"
                              [options]="allTypeOfMeansOfTransportKeys"
                            [inputFormatter]="typeOfMeansOfTransportFormatter"></app-search>
                          </app-form-field>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Identification" class="col-6 col-md-4"
                            [(value)]="masterLevel.activeBorderTransportMeans.vehicle.identificationNumber"
                            [editMode]="editMode"
                            [includeMargin]="false">
                            <input required class="input-group form-control"
                              [(ngModel)]="masterLevel.activeBorderTransportMeans.vehicle.identificationNumber"/>
                          </app-form-field>
                          <app-form-field label="Registration Nationality" class="col-6 col-md-4"
                            [(value)]="masterLevel.activeBorderTransportMeans.vehicle.nationality"
                            [editMode]="editMode"
                            [includeMargin]="false">
                            <app-search required
                              [(ngModel)]="masterLevel.activeBorderTransportMeans.vehicle.nationality"
                              [searchFunction]="refData.findCountries"
                              [resultFormatter]="refData.countryFormatter" [inputFormatter]="countryFormatter"
                              (ngModelChange)="masterLevel.activeBorderTransportMeans.vehicle.nationality = countryFormatter($event)">
                            </app-search>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    @if (editMode) {
                      @if (rules.isPlaceOfAcceptanceMasterLevelAllowed(consignmentProcess)) {
                        <div class="col-12">
                          <div class="row gy-4">
                            <app-form-field label="Place of acceptance" class="col-6 col-md-4"
                              [(value)]="masterLevel.placeOfAcceptance"
                              [editMode]="editMode" [includeMargin]="false"
                              [formatter]="utils.placeFormatter"
                              tooltip="The location where the goods are taken over from the consignor"
                              [checkForErrors]="true">
                              <app-search [(ngModel)]="masterLevel.placeOfAcceptance"
                                [required]="rules.isPlaceOfAcceptanceMasterLevelRequired(consignmentProcess)"
                                [inputFormatter]="utils.placeFormatter" (ngModelChange)="updateRoutes()"
                              [searchFunction]="refData.findLocation"></app-search>
                            </app-form-field>
                          </div>
                        </div>
                      }
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Place of loading" class="col-6 col-md-4"
                            [(value)]="masterLevel.placeOfLoading" [editMode]="editMode"
                            [includeMargin]="false" [formatter]="utils.placeFormatter"
                            [checkForErrors]="true">
                            <app-search [(ngModel)]="masterLevel.placeOfLoading"
                              [minCharacters]="itineraryOfVisit != null ? 0 : 1"
                              (ngModelChange)="onPlaceOfLoadingChange($event)"
                              [inputFormatter]="utils.placeFormatter"
                              [searchFunction]="itineraryOfVisit != null ? findInPreviousPorts : refData.findLocation"
                            required></app-search>
                          </app-form-field>
                          <app-estimated-actual-field
                            class="col-6 col-md-8"
                            [(estimate)]="masterLevel.activeBorderTransportMeans.estimatedDateAndTimeOfDeparture"
                            [(actual)]="masterLevel.activeBorderTransportMeans.actualDateAndTimeOfDeparture"
                            [editMode]="editMode" label="Time of departure" (estimateChange)="updateRoutes()"
                            [required]="rules.isEnsFiling(consignmentProcess)" (actualChange)="updateRoutes()"></app-estimated-actual-field>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Port of discharge" class="col-4 col-md-4"
                            [(value)]="masterLevel.placeOfUnloading"
                            [editMode]="editMode" [includeMargin]="false"
                            [formatter]="utils.placeFormatter">
                            <app-search [(ngModel)]="masterLevel.placeOfUnloading"
                              [minCharacters]="itineraryAfterVisit != null ? 0 : 1"
                              (ngModelChange)="onPlaceOfUnloadingChange($event)"
                              [inputFormatter]="utils.placeFormatter"
                              [searchFunction]="itineraryAfterVisit != null ? findInCurrentAndNextPorts : refData.findLocation"
                            required></app-search>
                          </app-form-field>
                          @if (rules.isDischargeTerminalAllowed(consignmentProcess)) {
                            <app-form-field
                              label="Terminal" class="col-4 col-md-4"
                              [(value)]="masterLevel.dischargeTerminal"
                              [editMode]="editMode" [includeMargin]="false"
                              [formatter]="refData.terminalFormatter">
                              @if (!!terminalsOfVisit) {
                                <app-search [(ngModel)]="masterLevel.dischargeTerminal"
                                  [inputFormatter]="refData.terminalFormatter" (ngModelChange)="onTerminalChange($event)"
                                  [optionsProvider]="terminalsOfVisit" dataKey="terminalCode" required
                                  placeholder="Search for terminal">
                                </app-search>
                              }
                            </app-form-field>
                          }
                          @if (rules.isDutchPort(consignmentProcess)) {
                            <app-form-field label="Terminal License" class="col-4 col-md-4"
                              [(value)]="masterLevel.terminalLicense"
                              [editMode]="editMode" [includeMargin]="false"
                              [checkForErrors]="true">
                              <input class="input-group form-control" [(ngModel)]="masterLevel.terminalLicense"/>
                            </app-form-field>
                          }
                        </div>
                      </div>
                      @if (rules.isPlaceOfDeliveryMasterLevelAllowed(consignmentProcess)) {
                        <div class="col-12">
                          <div class="row gy-4">
                            <app-form-field label="Place of delivery" class="col-6 col-md-4"
                              [(value)]="masterLevel.placeOfDelivery"
                              [editMode]="editMode" [includeMargin]="false"
                              [formatter]="utils.placeFormatter"
                              tooltip="The location at which the goods are to be received by the consignee"
                              [checkForErrors]="true">
                              <app-search [(ngModel)]="masterLevel.placeOfDelivery"
                                [inputFormatter]="utils.placeFormatter" (ngModelChange)="updateRoutes()"
                                [required]="rules.isPlaceOfDeliveryMasterLevelRequired(consignmentProcess)"
                              [searchFunction]="refData.findLocation"></app-search>
                            </app-form-field>
                          </div>
                        </div>
                      }
                    }
                    @if (!editMode || !consignmentProcess.filing.crn) {
                      <div class="col-12">
                        <div class="d-inline-block mb-3">
                          <span class="h2">Route</span>
                          @if (rules.isTemporaryStorageOnlyConsignment(consignmentProcess.filing.filingType)) {
                            <app-tooltip [placement]="'top'" class="ms-1">
                              <i class="fa-light fa-circle-info info-icon text-black"></i>
                              <div class="tooltipContent">
                                <div class="tooltip-card">
                                  <div class="tooltip-card-body">
                                    <div class="text-start">
                                      <h6>Filing type</h6>
                                      <p>The filing type has been automatically set
                                      to {{ consignmentProcess.filing.filingType }} based on the itinerary</p>
                                      <p>This means no ENS will be send by Portbase</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </app-tooltip>
                          }
                        </div>
                        @if (editMode) {
                          <p>A minimum of 2 countries is required, one of which must be a member of the
                          European Union.</p>
                        }
                        <div class="consignment-routes row gy-4">
                          @for (route of routes; track route; let i = $index) {
                            <div class="col-12">
                              <app-master-consignment-route [routeInfo]="route" [index]="i" [editMode]="editMode"
                              [(allRoutes)]="routes"></app-master-consignment-route>
                            </div>
                          }
                        </div>
                        @if (editMode) {
                          <div class="row mt-3">
                            <div class="col-auto">
                              <button class="btn btn-outline-primary text-decoration-none" (click)="addRoute()">
                                <i class="fa-lg fa-light fa-plus"></i>
                                <span class="ps-2 d-none d-md-inline">Add country</span>
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (!rules.isRoadConsignment(consignmentProcess) && rules.isEnsFiling(consignmentProcess)) {
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Filing"
                                          class="col-12"
                                          [(value)]="billOfLadingFilingType.filing"
                                          [includeMargin]="false" [editMode]="editMode" [renderOptional]="false"
                                          [formatter]="refData.enumFormatter" [tooltipTemplateRef]="filingTypeTooltip">
                            <app-radio [(ngModel)]="billOfLadingFilingType.filing" (ngModelChange)="updateFilingType()"
                                       [inline]="true" [options]="filingTypes" [formatter]="refData.enumFormatter"
                                       required></app-radio>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    @if (editMode && rules.isReEntryIndicatorAllowed(consignmentProcess)) {
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="European Union re-entry?" class="col-12"
                            [(value)]="consignmentProcess.filing.reEntryIndicator"
                            [editMode]="editMode" [includeMargin]="false">
                            <div class="d-block mb-2">
                              <span class="text-secondary">Does the cargo enter the EU again, without having been unloaded or transhipped outside the EU?</span>
                            </div>
                            <app-yes-no [required]=rules.isReEntryIndicatorRequired(consignmentProcess)
                            [(ngModel)]="consignmentProcess.filing.reEntryIndicator"></app-yes-no>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    @if (editMode && rules.isCustomsOfficeFirstEntryAllowed(consignmentProcess)) {
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Customs office first entry" class="col-6 col-md-4"
                            [(value)]="consignmentProcess.filing.customsOfficeOfFirstEntry"
                            [editMode]="editMode" [includeMargin]="false"
                            [formatter]="utils.customsOfficeFormatter">
                            <app-search [(ngModel)]="consignmentProcess.filing.customsOfficeOfFirstEntry"
                              [required]="rules.isCustomsOfficeFirstEntryRequired(consignmentProcess)"
                              [options]="customsOffices" dataKey="name" (ngModelChange)="updateRoutes()"
                            [inputFormatter]="utils.customsOfficeFormatter"></app-search>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    @if (editMode) {
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Estimated time of arrival" class="col-6 col-md-6"
                            [(value)]="masterLevel.activeBorderTransportMeans.estimatedDateAndTimeOfArrival"
                            [editMode]="editMode" [includeMargin]="false" [checkForErrors]="true">
                            <app-date-field
                              [(ngModel)]="masterLevel.activeBorderTransportMeans.estimatedDateAndTimeOfArrival"
                            required></app-date-field>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    <div class="col-12">
                      <div class="row">
                        @if (masterLevel.transportCharges && rules.isTransportChargesAllowed(consignmentProcess)) {
                          <app-form-field label="Payment method" class="col col-md-6"
                            [(value)]="masterLevel.transportCharges.methodOfPayment"
                            [editMode]="editMode" [includeMargin]="false"
                            [formatter]="utils.methodOfPaymentFormatter">
                            <app-select
                              [(ngModel)]="masterLevel.transportCharges.methodOfPayment"
                              [options]="utils.methodsOfPayment"
                              [required]="rules.isTransportChargesAllowed(consignmentProcess)"
                            [formatter]="utils.methodOfPaymentFormatter"></app-select>
                          </app-form-field>
                        }
                        @if (rules.isExchangeRateAllowed(this.consignmentProcess) && masterLevel.exchangeRate) {
                          <app-form-field label="Currency" class="col-6 col-md-3"
                            [(value)]="masterLevel.exchangeRate.currency"
                            [editMode]="editMode"
                            [includeMargin]="false" [formatter]="refData.currenciesFormatter">
                            <app-search [(ngModel)]="masterLevel.exchangeRate.currency"
                              dataKey="unCode" [optionsProvider]="refData.getCurrencies"
                            [inputFormatter]="refData.currenciesFormatter"></app-search>
                          </app-form-field>
                          <app-form-field label="Exchange rate" class="col col-md-3"
                            [(value)]="masterLevel.exchangeRate.rate"
                            [editMode]="editMode"
                            [includeMargin]="false">
                            <input class="input-group form-control"
                              [(ngModel)]="masterLevel.exchangeRate.rate"/>
                          </app-form-field>
                        }
                      </div>
                    </div>
                    @if (rules.isCustomsStatusAllowed(consignmentProcess)) {
                      <div class="col-12">
                        <div class="row gy-4">
                          <app-form-field label="Transport condition" class="col-6 col-md-4"
                            [(value)]="masterLevel.transportConditionCode"
                            [editMode]="editMode"
                            [includeMargin]="false" [formatter]="refData.enumFormatter">
                            <app-search [(ngModel)]="masterLevel.transportConditionCode"
                              [options]="utils.transportConditionCodes"
                              [inputFormatter]="refData.enumFormatter"
                            [resultFormatter]="refData.enumFormatter"></app-search>
                          </app-form-field>
                        </div>
                      </div>
                    }
                    <div class="col-12">
                      <div class="row">
                        @if (rules.isCustomsStatusAllowed(consignmentProcess)) {
                          <app-form-field label="Customs status" class="col-6 col-md-3"
                            [(value)]="masterLevel.customsStatus"
                            [editMode]="editMode"
                            [includeMargin]="false" [formatter]="refData.enumFormatter">
                            <app-search [(ngModel)]="masterLevel.customsStatus"
                              (ngModelChange)="onCustomStatusChange($event)"
                              [options]="utils.customsStatuses"
                            [inputFormatter]="utils.customsStatusFormatter"></app-search>
                          </app-form-field>
                        }
                        @if (rules.isCustomsProcessAllowed(this.consignmentProcess)) {
                          <app-form-field label="Customs process" class="col col-md-6"
                            [(value)]="masterLevel.customsProcess"
                            [editMode]="editMode"
                            [includeMargin]="false" [formatter]="utils.customProcessNameFormatter">
                            <app-search [(ngModel)]="masterLevel.customsProcess"
                              [options]="utils.customsProcesses" (ngModelChange)="updateFilingType()"
                            [inputFormatter]="utils.customProcessNameFormatter"></app-search>
                          </app-form-field>
                        }
                      </div>
                    </div>
                    @if (ConsignmentRules.isPreviousDocumentAllowed(consignmentProcess)) {
                      <div class="col-12">
                        <label class="h2 fw-regular">Documents</label>
                        @if (editMode) {
                          <span class="form-field-optional text-secondary ms-1">(optional)</span>
                        }
                        <div class="row">
                          <app-form-field label="Previous document" class="col col-md-4"
                            [(value)]="masterLevel.previousDocument.type"
                            [editMode]="editMode"
                            [includeMargin]="false" [formatter]="utils.supportingDocumentTypeFormatter"
                            [checkForErrors]="'Previous document type'">
                            <app-search [(ngModel)]="masterLevel.previousDocument.type"
                              placeholder="Select document type"
                              [options]="utils.documentTypes"
                              [inputFormatter]="utils.supportingDocumentTypeFormatter"
                            [required]="false"></app-search>
                          </app-form-field>
                          <app-form-field label="Reference number"
                            [(value)]="masterLevel.previousDocument.identification"
                            class="col col-md-3"
                            [editMode]="editMode" [includeMargin]="false"
                            [checkForErrors]="'Previous document number'">
                            <input class="input-group form-control"
                              [required]="false"
                              [(ngModel)]="masterLevel.previousDocument.identification"
                              (ngModelChange)="updatePreviousDocument($event)"/>
                          </app-form-field>
                          @if (masterLevel.previousDocument.type === 'N355') {
                            <app-form-field label="ENS transport document type"
                                            [(value)]="masterLevel.previousDocument.ensTransportDocumentType"
                                            class="col col-md-5"
                                            [editMode]="editMode" [includeMargin]="false">
                              <app-search [(ngModel)]="masterLevel.previousDocument.ensTransportDocumentType"
                                          placeholder="Select ENS transport document type"
                                          [options]="utils.ensTransportDocumentTypes"
                                          [inputFormatter]="utils.ensTransportDocumentTypeFormatter"
                                          [required]="false"></app-search>
                            </app-form-field>
                          }
                        </div>
                      </div>
                    }
                    @for (supportingDocument of masterLevel.supportingDocuments; track $index) {
                      <div class="col-12">
                        <div class="row">
                          <app-form-field label="Supporting documents" class="col col-md-7" [truncateReadOnly]="true"
                            [value]="supportingDocument.type" [editMode]="editMode"
                            [includeMargin]="false" [formatter]="utils.documentTypeFormatter"
                            [checkForErrors]="'Supporting document type'">
                            <app-search [(ngModel)]="supportingDocument.type" [minCharacters]="0"
                              [inputFormatter]="utils.documentTypeFormatter"
                              [searchFunction]="utils.findDocumentTypes"
                            placeholder="Select a document type"></app-search>
                          </app-form-field>
                          <app-form-field label="Reference number" [value]="supportingDocument.referenceNumber"
                            class="col col-md-3"
                            [editMode]="editMode" [includeMargin]="false"
                            [checkForErrors]="'Supporting document number'">
                            <input class="input-group form-control" required
                              [(ngModel)]="supportingDocument.referenceNumber"/>
                          </app-form-field>
                          @if (editMode) {
                            <div class="col-auto d-flex align-items-center pt-5">
                              <button class="btn rounded-circle p-1 px-2 text-danger h1 mb-0"
                                (click)="deleteSupportingDocument(supportingDocument)">
                                <i class="fa-light fa-trash-can"></i>
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <div class="col-12">
                      @if (editMode) {
                        <div class="row mt-3">
                          <div class="col-auto">
                            <button class="btn btn-outline-primary text-decoration-none"
                              (click)="addSupportingDocument()">
                              <i class="fa-lg fa-light fa-plus"></i>
                              <span class="ps-2 d-none d-md-inline">Add supporting document</span>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-tab-item>
      @if (showDetails()) {
        <app-tab-item [templateRef]="supplyChainActorsRef">
          <span class="tab-item">
            <span errorIndicator [predicate]="partyPredicate" [overrideRef]="elementRef"></span>
            Parties
          </span>
          <ng-template #supplyChainActorsRef>
            <div class="container py-3">
              <div class="card">
                <div class="card-body p-5">
                  <div class="row gy-4 my-5">
                    <h5 class="h1 col-12 m-0">Parties</h5>
                    <div class="col-12">
                      <app-consignment-carrier-details [(carrier)]="masterLevel.carrier"
                        [required]="true"
                        [editMode]="editMode"
                        [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                        [filingType]="consignmentProcess.filing.filingType"
                      label="Carrier"></app-consignment-carrier-details>
                    </div>
                    @if (!rules.isStraightConsignment(consignmentProcess)) {
                      <div class="col-12">
                        <app-consignment-party-details
                          [(party)]="masterLevel.consignee"
                          [editMode]="editMode" [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                          [filingType]="consignmentProcess.filing.filingType"
                        label="Consignee"></app-consignment-party-details>
                      </div>
                      <div class="col-12">
                        <app-consignment-party-details
                          [(party)]="masterLevel.consignor"
                          [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                          [editMode]="editMode" [required]="rules.isConsignorMasterLevelRequired(consignmentProcess)"
                          [filingType]="consignmentProcess.filing.filingType"
                        label="Consignor"></app-consignment-party-details>
                      </div>
                      @if (consignmentProcess.filing.filingType === 'F12') {
                        <div class="col-12">
                          <app-consignment-supplementary-declarant
                            [(supplementaryDeclarant)]="masterLevel.supplementaryDeclarant"
                            [supplementaryFilingType]="'N1'"
                            [editMode]="editMode" [required]="true"
                          label="Supplementary declarant"></app-consignment-supplementary-declarant>
                        </div>
                      }
                    }
                  </div>
                  @if (masterLevel.notifyParties?.length || editMode) {
                    <div class="row gy-4 my-5">
                      <h5 class="h1 col-12 m-0">Notify parties</h5>
                      @for (party of masterLevel.notifyParties; track $index; let i = $index) {
                        <div class="col-12">
                          <app-consignment-party-details
                            [(party)]="masterLevel.notifyParties[i]" (partyChange)="checkPartyDeletion($event, i)"
                            [cargoDeclarantId]="consignmentProcess.filing.declarant.iamConnectedId"
                            [editMode]="editMode" [required]="true" [deletionAllowed]="true"
                            [communicationRequired]="true"
                            [filingType]="consignmentProcess.filing.filingType"
                          [label]="party.name || 'Notify party'"></app-consignment-party-details>
                        </div>
                      }
                      @if (editMode) {
                        <div class="col-12">
                          <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" (click)="addNotifyParty()">
                              <i class="fa-lg fa fa-fw fa-plus"></i>
                              Add notify party
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (!rules.isStraightConsignment(consignmentProcess) && !rules.isRoadConsignment(consignmentProcess)) {
                    <div class="row gy-4 my-5">
                      @if (masterLevel.additionalSupplyChainActors?.length || editMode) {
                        <h5 class="h1 col-12 m-0">Supply chain actors</h5>
                        @for (supplyChainActor of masterLevel.additionalSupplyChainActors; track $index; let i = $index) {
                          <div class="col-12"
                            >
                            <app-additional-supply-chain-actor-details [consignmentProcess]="consignmentProcess"
                              [supplyChainActor]="supplyChainActor"
                              [editMode]="editMode"
                              (supplyChainActorChange)="checkSupplyChainActorDeletion($event, i)"
                            [label]="utils.supplyChainTypeFormatter(supplyChainActor.type)"></app-additional-supply-chain-actor-details>
                          </div>
                        }
                        @if (editMode) {
                          <div class="col-12">
                            <div class="col-auto dropdown">
                              <button type="button" class="btn btn-outline-primary" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                <i class="fa-lg fa fa-fw fa-plus"></i>
                                Add actor
                              </button>
                              <div class="dropdown-menu">
                                @for (type of utils.additionalSupplyChainTypes; track $index) {
                                  <button class="btn dropdown-item" (click)="addSupplyChainActor(type)">
                                    {{ utils.supplyChainTypeFormatter(type) }}
                                  </button>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                  @if (rules.isBulkAuthorizationAllowed(consignmentProcess)) {
                    <div class="row gy-4 my-5">
                      @if (masterLevel.bulkAuthorisations?.length || editMode) {
                        <h5 class="h1 col-12 m-0">Access to discharge information</h5>
                        @for (organisation of masterLevel.bulkAuthorisations; track $index; let i = $index) {
                          <div class="col-12">
                            <app-consignment-organisation-party-details
                              [(organisation)]="masterLevel.bulkAuthorisations[i]" [editMode]="editMode"
                            (organisationChange)="checkBulkAuthorisationDeletion($event, i)"></app-consignment-organisation-party-details>
                          </div>
                        }
                        @if (editMode) {
                          <div class="col-12">
                            <div class="col-auto">
                              <button type="button" class="btn btn-outline-primary" (click)="addBulkAuthorisation()">
                                <i class="fa-lg fa fa-fw fa-plus"></i>
                                Add authorisation
                              </button>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </ng-template>
        </app-tab-item>
        @if ((!rules.isStraightConsignment(consignmentProcess) && !rules.isRoadConsignment(consignmentProcess))
          || rules.isTemporaryStorageOnlyConsignment(consignmentProcess.filing.filingType)) {
          <app-tab-item
            [templateRef]="goodsRef">
            <span class="tab-item">
              <span errorIndicator [predicate]="goodsItemPredicate" [overrideRef]="elementRef"></span>
              <span>Goods</span>
              <span class="ps-2 fw-light">{{ goodsItems.length }}</span>
            </span>
            <ng-template #goodsRef>
              <app-consignment-goods-table [data]="goodsItems" [editable]="isEditable"
              [consignmentProcess]="consignmentProcess"
              [errorGoodsItemNumbers]="errorGoodsItemNumbers"></app-consignment-goods-table>
            </ng-template>
          </app-tab-item>
        }
        @if (equipmentSupported) {
          <app-tab-item [templateRef]="equipmentRef">
            <span class="tab-item">
              <span errorIndicator [predicate]="equipmentPredicate" [overrideRef]="elementRef"></span>
              <span>Equipment</span>
              <span class="ps-2 fw-light">{{ transportEquipmentCount }}</span>
            </span>
            <ng-template #equipmentRef>
              <app-consignment-equipments-table [data]="equipments"
              [editable]="isEditable"
              [errorEquipmentNumbers]="errorEquipmentNumbers"></app-consignment-equipments-table>
            </ng-template>
          </app-tab-item>
        }
        @if (utils.houseConsignmentSupported(consignmentProcess)) {
          <app-tab-item [templateRef]="houseConsignmentsRef">
            <div class="tab-item">
              <span errorIndicator [predicate]="houseLevelPredicate" [overrideRef]="elementRef"></span>
              <span>House B/Ls</span>
              <span class="ps-2 fw-light">{{ masterLevel.consignmentsHouseLevel.length }}</span>
            </div>
            <ng-template #houseConsignmentsRef>
              <app-house-consignments-table [data]="houseConsignments" [editable]="isEditable"
              [consignmentProcess]="consignmentProcess"
              [errorConsignmentNumbers]="errorHouseConsignmentNumbers"></app-house-consignments-table>
            </ng-template>
          </app-tab-item>
        }
        <app-tab-item [templateRef]="historyRef" [alwaysRender]="false">
          <span class="tab-item">History</span>
          <ng-template #historyRef>
            <app-consignment-history-details
            [consignmentProcess]="consignmentProcess"></app-consignment-history-details>
          </ng-template>
        </app-tab-item>
      }
    </app-tab-panel>
  </div>
  @if (!consignmentProcess.fromVisit) {
    <div class="modal-footer">
      <div class="d-flex flex-grow-1">
        <div class="container">
          <div class="row mx-4">
            <div class="col-auto">
              <button type="button" class="btn btn-outline-danger" (click)="remove()">Remove</button>
            </div>
            <div class="col-auto ms-auto">
              @if (!editMode) {
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close"
                  >
                  Close
                </button>
              }
              @if (editMode) {
                <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
                  Cancel
                </button>
              }
            </div>
            <div class="col-auto">
              @if (editMode) {
                @if (utils.hasBeenDeclared(consignmentProcess)) {
                  <button type="button" class="btn btn-primary" (click)="toggleEdit()"
                    >Ok
                  </button>
                }
                @if (!utils.hasBeenDeclared(consignmentProcess)) {
                  <button type="button" class="btn btn-primary" (click)="save()"
                    >Save
                  </button>
                }
                <!--Disable the tooltip when consignment is complete-->
                @if (!utils.hasBeenDeclared(consignmentProcess) && isAllowedToDeclare) {
                  <app-tooltip [placement]="'top'"
                    [disabled]="(consignmentProcess.complete || isNewConsignment || consignmentProcess.expectedNumberOfHouseConsignments === 0)">
                    <button type="button" class="btn btn-primary mx-4" (click)="declare()"
                      [disabled]="!consignmentProcess.complete && !isNewConsignment && consignmentProcess.expectedNumberOfHouseConsignments > 0">
                      {{consignmentProcess?.cancelled ? "Re-open" : "Declare"}}
                    </button>
                    @if (!consignmentProcess.complete && !isNewConsignment && consignmentProcess.expectedNumberOfHouseConsignments > 0) {
                      <div class="tooltipContent">
                        <div class="text-start">
                          Not allowed to declare yet since the expected number of house consignments
                          ({{ consignmentProcess.expectedNumberOfHouseConsignments }}) is not equal to the actual amount
                          of
                          house consignments ({{ masterLevel.consignmentsHouseLevel?.length }})
                        </div>
                      </div>
                    }
                  </app-tooltip>
                }
              } @else {
                @if (isEditableForTab) {
                  <button type="button" class="btn btn-outline-secondary me-4" (click)="startEditing()">
                    Edit
                  </button>
                }
                <!--Disable the tooltip when consignment is complete-->
                @if (isAllowedToDeclare) {
                  <app-tooltip [placement]="'top'"
                    [disabled]="(consignmentProcess.complete || isNewConsignment || consignmentProcess.expectedNumberOfHouseConsignments === 0)">
                    <button type="button" class="btn btn-primary" (click)="declare()"
                      [disabled]="!consignmentProcess.complete && !isNewConsignment && consignmentProcess.expectedNumberOfHouseConsignments > 0">
                      {{ utils.hasBeenDeclared(consignmentProcess) ? consignmentProcess.cancelled ? 'Re-open' : 'Update' : 'Declare' }}
                    </button>
                    @if (!consignmentProcess.complete && !isNewConsignment && consignmentProcess.expectedNumberOfHouseConsignments > 0) {
                      <div class="tooltipContent">
                        <div class="text-start">
                          Not allowed to declare yet since the expected number of house consignments
                          ({{ consignmentProcess.expectedNumberOfHouseConsignments }}) is not equal to the actual amount
                          of
                          house consignments ({{ masterLevel.consignmentsHouseLevel?.length }})
                        </div>
                      </div>
                    }
                  </app-tooltip>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

<ng-template #mainFilingTooltip>
  <div class="text-start">
    <h6>Union goods transported under Regular Shipping Service License</h6>
    <p>For these goods, no TSD will be filed to Customs NL.</p>
    <p>The submitted data is used solely for reuse in other PCS services.</p>
    <p>Only select *YES* if the consignment contains union goods and would be shipped as part of a customs authorised
      RSS (Regular Shipping Service) license between EU-ports.</p>
  </div>
</ng-template>

<ng-template #filingTypeTooltip>
  <div class="text-start">
    <h6>Filing type</h6>
    <p>Single filing means that you must submit all required bill of lading data at both master and house level.</p>
    <p>Multiple filing means that you must submit all required bill of lading data at master level. For the ENS, the bill of lading data at house level is submitted by the supplementary declarant.</p>
  </div>
</ng-template>

<ng-template #billOfLadingTooltip>
  <div class="text-start">
    <h6>Bill of lading</h6>
    <p>‘Straight’ Bill of Lading (B/L) is non-negotiable and is also known as 'B/L op naam' or 'Recta connossement'.</p>
    <p>To help you choose, you can check the following on your B/L: Is the consignee known by name or unknown (‘To
    order’)? If known, we suggest choosing ‘Straight’. If unknown, we suggest choosing ‘Non-Straight’.</p>
    <p>If you are not familiar with using B/L’s but ‘Bookings’, we also suggest using ‘Straight’.</p>
  </div>
</ng-template>
<ng-template #modeOfTransportTooltip>
  <div class="text-start">
    <h6>Mode of transport</h6>
    <p>The mode of transport is either maritime or road.</p>
  </div>
</ng-template>
